import React from 'react'
import { View } from 'react-native'
// import LottieView from 'lottie-react-native'
import PropTypes from 'prop-types'

import styles from './Loading.Styles'

import source from './loaderE60000.json'


const Loading = ({ theme }) => {
  return (
    // <View
    //   onStartShouldSetResponder={() => true}
    //   style={styles.container(theme)}
    // >
    //   <View>
    //     <LottieView
    //       style={styles.lottie}
    //       autoPlay
    //       loop={true}
    //       source={source}
    //     />
    //   </View>
    // </View>
    <div></div>
  )
}
Loading.propTypes = {
  theme: PropTypes.object,
}

export default Loading
